export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-title">
                    Загальна характеристика
                </p>
                <p className="card__description-text">
                    АВАЛОН 7+ (НС 6046) — це високопродуктивний класичний гібрид соняшнику, який поєднує ранньостиглість, стабільність та потужну стійкість до вовчка. Ідеальний вибір для господарств, які працюють за традиційною технологією та прагнуть отримати високий урожай без використання спеціалізованих гербіцидних систем.
                </p>
                <p className="card__description-text">
                    Гібрид характеризується високою посухостійкістю та здатністю формувати стабільний урожай навіть у складних погодних умовах.
                </p>
                <p className="card__description-title">Основні переваги</p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Потенціал урожайності — до 5,3 т/га</li>
                    <li className="card__description-numbering">Ранній гібрид — швидке дозрівання</li>
                    <li className="card__description-numbering">Стійкість до вовчка — 7+ рас (A–G+)</li>
                    <li className="card__description-numbering">Висока посухостійкість</li>
                    <li className="card__description-numbering">Висока стабільність у різних умовах</li>
                    <li className="card__description-numbering">Підходить для класичної технології вирощування</li>
                </ol>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Період вегетації</td>
                        <td className="card__description__th-index">97–102 дні</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність:</td>
                        <td className="card__description__th-index">48–50%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослин</td>
                        <td className="card__description__th-index">165–185 см</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Рекомендації по густоті
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">За достатнього зволоження: 55–60 тис. рослин/га</li>
                    <li className="card__description-numbering">У посушливих умовах: 40–45 тис. рослин/га</li>
                </ol>
                <div className="card__description-title">Стійкість та толерантність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Стійкість:
                    </p>
                    <li className="card__description-numbering">Посухостійкість, осипання — 9/10</li>
                    <li className="card__description-numbering">Холодостійкість, вилягання — 7/10</li>
                    <p className="card__description-text">
                        Толерантність до хвороб:
                    </p>
                    <li className="card__description-numbering">Іржа, вугільна гниль, біла та сіра гнилі — 9/10</li>
                    <li className="card__description-numbering">Фомопсис, фомоз, альтернаріоз — 8/10</li>
                    <li className="card__description-numbering">Пероноспороз, септоріоз — 7/10</li>
                </ol>
                <div className="card__description-title">Рекомендовані зони вирощування</div>
                <p className="card__description-text">
                    Гібрид ефективний у всіх агрокліматичних зонах України, особливо добре проявляє себе у Степу та Лісостепу, де важлива рання віддача врожаю та посухостійкість.
                </p>
                <div className="card__description-title">Рекомендації щодо вирощування</div>
                <p className="card__description-text">
                    АВАЛОН 7+ — ідеальний вибір для класичної технології вирощування без застосування систем Clearfield® або SUMO®. Добре реагує на стандартний агрофон і демонструє стабільний результат навіть у стресових умовах. Рекомендується дотримання сівозміни та базових систем захисту рослин.
                </p>
                <p className="card__description-text">
                    АВАЛОН 7+ — це ідеальний варіант для тих, хто хоче простоту, стабільність і високий результат у класичній технології. Надійний гібрид для стабільного прибутку.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
